import { render, staticRenderFns } from "./Auftraege_Offen.vue?vue&type=template&id=181ff5f2&scoped=true"
import script from "./Auftraege_Offen.vue?vue&type=script&lang=js"
export * from "./Auftraege_Offen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ff5f2",
  null
  
)

export default component.exports